__webpack_require__.p = "https://admin.dim.atea.com/";